module.exports = __webpack_public_path__ + "img/WO.a199a275.png";